import styled, { css } from 'styled-components';

export const Wrapper = styled.div`
  display: inline-block;
  position: relative;
  width: 100%;
`;

export const TooltipBox = styled.div<{ $position: 'right-start' | 'top-end' }>`
  position: absolute;
  background-color: ${({ theme }) => theme.palette.system['black-80']};
  color: ${({ theme }) => theme.palette.primary.background};
  width: 325px;
  padding: 10px 15px;
  font-size: 14px;
  border-radius: 14px;
  z-index: 10201;

  ${({ $position }) =>
    $position === 'right-start' &&
    css`
      left: 100%;
      top: -10px;
      margin-left: 16px;

      &::before {
        content: '';
        position: absolute;
        top: 20px;
        left: -20px;
        border-width: 10px;
        border-style: solid;
        border-color: transparent
          ${({ theme }) => theme.palette.system['black-80']} transparent
          transparent;
      }
    `}

  ${({ $position }) =>
    $position === 'top-end' &&
    css`
      bottom: 100%;
      left: 70%;
      margin-bottom: 16px;

      &::before {
        content: '';
        position: absolute;
        top: 100%;
        left: 40px;
        border-width: 10px;
        border-style: solid;
        border-color: ${({ theme }) => theme.palette.system['black-80']}
          transparent transparent transparent;
      }
    `}
`;

export const Arrow = styled.div<{ $position: 'right-start' | 'top-end' }>`
  position: absolute;
  width: 8px;
  height: 8px;
  background-color: ${({ theme }) => theme.palette.system['black-80']};
  transform: rotate(45deg);

  ${({ $position }) =>
    $position === 'right-start'
      ? css`
          top: 8px;
          left: -4px;
        `
      : css`
          bottom: -4px;
          right: 8px;
        `}
`;
